import BannerWrapper from './BannerWrapper.component';

export default BannerWrapper;